import Vue from 'vue';
import { pollWhileVisible } from '@utils/pollWhileVisible';

const CHECK_INTERVAL_MS = 10 * 60 * 1000;

export const appVersion = Vue.observable({ stale: false });

export async function checkForNewBuild(currentId = process.env.VUE_APP_BUILD_ID) {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' });
    if (!res.ok) return appVersion.stale;
    const { id } = await res.json();
    if (id && id !== currentId) appVersion.stale = true;
  } catch {
    // offline, or mid-deploy — the next tick tries again
  }
  return appVersion.stale;
}

// A newer build is live: the next page change becomes a full load instead of
// an in-app navigation. Query/hash changes stay in-app so tabs and filters
// don't reload the page under the user.
export const shouldReloadForNewBuild = (routeTo, routeFrom) => appVersion.stale && routeTo.path !== routeFrom.path;

export function watchForNewBuild() {
  if (process.env.NODE_ENV !== 'production' || !process.env.VUE_APP_BUILD_ID) return;
  const stop = pollWhileVisible(() => checkForNewBuild().then((isNewer) => isNewer && stop()), CHECK_INTERVAL_MS);
}
